import es6Promise from 'es6-promise'
import fetch from 'cross-fetch'
import HOSTNAME from './hostname'

es6Promise.polyfill() // polyfill older browsers that don't have promise support

function checkStatus(response) {
  if (response.status == 204) {
    // no content in the body, don't try to parse the response json
    return Promise.resolve()
  }
  if (response.status >= 200 && response.status < 300) {
    return response.json()
  }
  return response.json().then(Promise.reject.bind(Promise))
}

export default function (path, config = {}) {
  path = HOSTNAME + path
  const credentials = 'same-origin'
  const headers = config.headers || {}

  // only set content type if the request is not a GET, HEAD, or DELETE
  if (
    config.method &&
    config.method != 'GET' &&
    config.method != 'HEAD' &&
    config.method != 'DELETE'
  ) {
    headers['Content-Type'] = 'application/json'
    // if there's no body add one b/c the server expects it when the content type is json
    if (!config.body) {
      config.body = JSON.stringify({})
    }
  }

  const csrfMeta = document.querySelector('meta[name="csrf-token"]')
  if (csrfMeta) {
    headers['X-CSRF-Token'] = csrfMeta.getAttribute('content')
  }

  // Inflect keys to camel case by default
  if (config.inflectKeys !== false) {
    headers['X-Key-Inflection'] = 'camel'
  }
  delete config.inflectKeys
  config = { ...config, credentials, headers }
  return fetch(path, config).then(checkStatus)
}
